import React, { FC } from 'react';
import { Collapse, CollapseProps } from 'antd';
import { ArrowDownShort, ArrowRightShort } from 'common/svg';

interface IComponentProps {
  keys: string[];
  items: CollapseProps['items'];
}

export const CardCollapse: FC<IComponentProps> = ({ keys, items }) => {
  return (
    <Collapse
      className="card-collapse"
      ghost
      expandIconPosition="end"
      expandIcon={({ isActive }) =>
        isActive ? (
          <ArrowDownShort className="icon-arrow-down-short-dark-grey" />
        ) : (
          <ArrowRightShort className="icon-arrow-right-short-dark-grey" />
        )
      }
      defaultActiveKey={keys}
      items={items}
    />
  );
};
